import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import {
  HelpMenu as HelpMenuComponent,
  NavMenuLink as MenuLink,
} from '@apps-common/ui-components/NavBar';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';

import {MODALS} from '@explorer/constants';
import {showModal} from '@explorer/actions/ui';
import {startTour} from '@explorer/actions/tour';
import {trackEvent} from '@explorer/analytics';

const HelpMenu = ({startTour, showModal, ...props}) => {
  const {t} = useTranslation();
  const onTermsClick = () => {
    showModal(MODALS.ATTRIBUTION);
  };

  const onTourStart = () => {
    trackEvent('Take a Tour button clicked');
    startTour();
  };

  return (
    <HelpMenuComponent {...props}>
      <MenuLink
        href="https://developers.planet.com/tag/explorer.html"
        data-qe="whats-new"
      >
        {t('navbars.menuProductChanges')}
      </MenuLink>
      <MenuLink
        href="https://developers.planet.com/docs/apps/explorer/"
        data-qe="user-guide"
      >
        {t('navbars.menuGuide')}
      </MenuLink>
      <MenuItem onClick={onTourStart} data-qe="take-tour">
        {t('navbars.menuTour')}
      </MenuItem>
      <MenuItem onClick={onTermsClick} data-qe="terms-of-service">
        {t('navbars.menuTerms')}
      </MenuItem>
      <Divider />
      <MenuLink
        href="https://community.planet.com/ideas"
        data-qe="leave-feedback-link"
      >
        {t('navbars.menuFeedback')}
      </MenuLink>
    </HelpMenuComponent>
  );
};

HelpMenu.propTypes = {
  startTour: PropTypes.func,
  showModal: PropTypes.func,
};

const mapDispatchProps = {
  showModal,
  startTour,
};

export default connect(null, mapDispatchProps)(HelpMenu);
